{"buildRevision":"74535841e267d1316fe2dffdf0d5545fc579518e","buildTimestamp":"2026-09-23T18:26:39.790Z","dirty":true,"version":"5.6.7"}